import { IApiPathManagerConfig } from './IApiPathManagerConfig';

export let _apiPathManagerConfig: IApiPathManagerConfig | undefined;

export const ApiPathManagerSetup = (props: IApiPathManagerConfig) => {
  _apiPathManagerConfig = props;
};
